export type GoogleReviewsMode = 'api' | 'embedded'

export const DEFAULT_GOOGLE_REVIEWS_MODE: GoogleReviewsMode = 'embedded'

export function parseGoogleReviewsMode(raw?: string | null): GoogleReviewsMode {
  return raw === 'api' ? 'api' : 'embedded'
}

export function parseGoogleReviewsEmbedUrl(raw?: string | null): string {
  const trimmed = String(raw ?? '').trim()
  if (!trimmed) return ''

  const srcMatch = trimmed.match(/src=["']([^"']+)["']/i)
  const candidate = srcMatch?.[1]?.trim() || trimmed

  try {
    const parsed = new URL(candidate)
    const host = parsed.hostname.toLowerCase()
    const isGoogleHost = host === 'google.com'
      || host.endsWith('.google.com')
      || host === 'maps.google.com'

    if (!isGoogleHost) return ''

    const path = parsed.pathname.toLowerCase()
    if (path.includes('/maps/embed') || path.includes('/maps')) {
      return parsed.toString()
    }
  } catch {
    return ''
  }

  return ''
}
